module.exports = __webpack_public_path__ + "static/media/ic_close.fa0d04b4.svg";